import React from 'react';
import './index.css';
import { Button, Checkbox, Select, FormControl, Input, InputAdornment, FormHelperText, MenuItem } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MaskedInput from 'react-text-mask';
import { RequestJSON } from '../../@types/requestJson/RequestJSON';

type MyProps = {
    requestJson: RequestJSON,
    personalInfomationOnChange: Function,
    loanInformationOnChange: Function,
    mortgageInformationOnChange: Function,
    creditInformationOnChange: Function,
    financialInformationOnChange: Function,
    educationInformationOnChange: Function,
    legalInformationOnChange: Function,
    tcpaLanguage: string,
    submitButtonOnClick: Function
}

class Form extends React.Component<MyProps, {}>{
    constructor(props: MyProps){
        super(props);
        this.TextMaskPhoneNumber = this.TextMaskPhoneNumber.bind(this);
        this.TextMaskSSN = this.TextMaskSSN.bind(this);
    }

    private TextMaskPhoneNumber(props: any){
        const { inputRef, ...other } = props;

        return(
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
            value={this.props.requestJson.personalInformation.primaryPhone} 
            onChange={(e) => this.props.personalInfomationOnChange("primaryPhone", e)}
        />
        );
    }

    private TextMaskSSN(props: any){
        const { inputRef, ...other} = props;

        return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
            value={this.props.requestJson.personalInformation.ssn}
            onChange={(e) => this.props.personalInfomationOnChange("ssn", e)}
        />            
        );
    }

    public render(){
        var date = this.props.requestJson.personalInformation.dateOfBirth;
        var fullDate = date.split("-"); //fullDate[0] = year, fullDate[1] = month, fullDate[2] = date
        var jsonDate = new Date(+fullDate[0], +fullDate[1]-1, +fullDate[2]);

        return (
        <div className="formBackground">
            <h1 id="formTitle">Apply for a personal loan.</h1>
            <p id="pageDesc">Fill out the fields below to see a complete API request JSON object.</p>
            <h4 className="objectTitle">Personal Information</h4>
            <div className="personalInfo">
                
                    <FormControl className="piInput">
                        <Input id="my-input5" aria-describedby="my-helper-text" value={this.props.requestJson.personalInformation.firstName} onChange={(e) => this.props.personalInfomationOnChange("firstName", e)}/>
                        <FormHelperText id="my-helper-text">Enter your first name here</FormHelperText>
                    </FormControl>
                    <FormControl className="piInput">
                        <Input id="my-input6" aria-describedby="my-helper-text" value={this.props.requestJson.personalInformation.lastName} onChange={(e) => this.props.personalInfomationOnChange("lastName", e)}/>
                        <FormHelperText id="my-helper-text">Enter your last name here</FormHelperText>
                    </FormControl>
                    <FormControl className="piInput">
                        <Input id="my-input3" aria-describedby="my-helper-text" value={this.props.requestJson.personalInformation.email} onChange={(e) => this.props.personalInfomationOnChange("email", e)}/>
                        <FormHelperText id="my-helper-text">We'll never share your email</FormHelperText>
                    </FormControl>
                    <FormControl className="piInput">
                        <Input id="cityInput" aria-describedby="my-helper-text" value={this.props.requestJson.personalInformation.city} onChange={(e) => this.props.personalInfomationOnChange("city", e)}/>
                        <FormHelperText id="cityInput">Enter your city here</FormHelperText>
                    </FormControl>
                
                    <FormControl className="piInput">
                        <Select id="stateSelect" aria-describedby="Please select your state." value={this.props.requestJson.personalInformation.state} onChange={(e) => this.props.personalInfomationOnChange("state", e)}>
                            <MenuItem value=" ">Choose one...</MenuItem>
                            <MenuItem value="AK">AK</MenuItem>
                            <MenuItem value="AL">AL</MenuItem>
                            <MenuItem value="AR">AR</MenuItem>
                            <MenuItem value="AZ">AZ</MenuItem>
                            <MenuItem value="CA">CA</MenuItem>
                            <MenuItem value="CO">CO</MenuItem>
                            <MenuItem value="CT">CT</MenuItem>
                            <MenuItem value="DC">DC</MenuItem>
                            <MenuItem value="DE">DE</MenuItem>
                            <MenuItem value="FL">FL</MenuItem>
                            <MenuItem value="GA">GA</MenuItem>
                            <MenuItem value="HI">HI</MenuItem>
                            <MenuItem value="IA">IA</MenuItem>
                            <MenuItem value="ID">ID</MenuItem>
                            <MenuItem value="IL">IL</MenuItem>
                            <MenuItem value="IN">IN</MenuItem>
                            <MenuItem value="KS">KS</MenuItem>
                            <MenuItem value="LA">LA</MenuItem>
                            <MenuItem value="MA">MA</MenuItem>
                            <MenuItem value="MD">MD</MenuItem>
                            <MenuItem value="ME">ME</MenuItem>
                            <MenuItem value="MI">MI</MenuItem>
                            <MenuItem value="MN">MN</MenuItem>
                            <MenuItem value="MO">MO</MenuItem>
                            <MenuItem value="MS">MS</MenuItem>
                            <MenuItem value="MT">MT</MenuItem>
                            <MenuItem value="NC">NC</MenuItem>
                            <MenuItem value="ND">ND</MenuItem>
                            <MenuItem value="NE">NE</MenuItem>
                            <MenuItem value="NH">NH</MenuItem>
                            <MenuItem value="NJ">NJ</MenuItem>
                            <MenuItem value="NM">NM</MenuItem>
                            <MenuItem value="NV">NV</MenuItem>
                            <MenuItem value="NY">NY</MenuItem>
                            <MenuItem value="OH">OH</MenuItem>
                            <MenuItem value="OK">OK</MenuItem>
                            <MenuItem value="OR">OR</MenuItem>
                            <MenuItem value="PA">PA</MenuItem>
                            <MenuItem value="PR">PR</MenuItem>
                            <MenuItem value="RI">RI</MenuItem>
                            <MenuItem value="SC">SC</MenuItem>
                            <MenuItem value="SD">SD</MenuItem>
                            <MenuItem value="TN">TN</MenuItem>
                            <MenuItem value="TX">TX</MenuItem>
                            <MenuItem value="UT">UT</MenuItem>
                            <MenuItem value="VA">VA</MenuItem>
                            <MenuItem value="VI">VI</MenuItem>
                            <MenuItem value="VT">VT</MenuItem>
                            <MenuItem value="WA">WA</MenuItem>
                            <MenuItem value="WI">WI</MenuItem>
                            <MenuItem value="WV">WV</MenuItem>
                            <MenuItem value="WY">WY</MenuItem>
                        </Select>
                        <FormHelperText id="stateSelect">Pick your state here.</FormHelperText> 
                    </FormControl>
                    <FormControl className="piInput">
                        <Input 
                            id="phoneInput" 
                            aria-describedby="my-helper-text" 
                            value={this.props.requestJson.personalInformation.primaryPhone} 
                            onChange={(e) => this.props.personalInfomationOnChange("primaryPhone", e)}
                            inputComponent={this.TextMaskPhoneNumber}
                        />
                        <FormHelperText id="phoneInput">Enter your phone number here</FormHelperText>
                    </FormControl>
                    <FormControl className="piInput">
                        <Input id="addressInput" aria-describedby="my-helper-text" value={this.props.requestJson.personalInformation.address1} onChange={(e) => this.props.personalInfomationOnChange("address1", e)}/>
                        <FormHelperText id="addressInput">Enter your address here</FormHelperText>
                    </FormControl>
                    <FormControl className="piInput">
                        <Input id="secondAddressInput" aria-describedby="my-helper-text" value={this.props.requestJson.personalInformation.address2} onChange={(e) => this.props.personalInfomationOnChange("address2", e)}/>
                        <FormHelperText id="secondAddressInput">Enter your second address here</FormHelperText>
                    </FormControl>
                
                    <FormControl className="piInput">
                        <Input id="zipcodeInput" aria-describedby="my-helper-text" value={this.props.requestJson.personalInformation.zipcode} onChange={(e) => this.props.personalInfomationOnChange("zipcode", e)}/>
                        <FormHelperText id="zipcodeInput">Enter your zipcode here</FormHelperText>
                    </FormControl>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker className="piInput" format="MM/dd/yyyy" value={jsonDate} onChange={date => this.props.personalInfomationOnChange("dateOfBirth", date)}/>
                    </MuiPickersUtilsProvider>
                    <FormControl className="piInput">
                        <Input id="ssnInout"
                        aria-describedby="my-helper-text"
                        value={this.props.requestJson.personalInformation.ssn}
                        onChange={(e) => this.props.personalInfomationOnChange("ssn", e)}
                        inputComponent={this.TextMaskSSN}
                        />
                        <FormHelperText id="ssnInput">Enter your social security number here</FormHelperText>
                    </FormControl>
            </div>
            <br/>
            <h4 className="objectTitle">Loan Information</h4>
            <div className="loanInfo">
                <FormControl className="formInputs">
                    <Select id="loanPurposeSelect" aria-describedby="Select your loan purpose here" value={this.props.requestJson.loanInformation.purpose} onChange={(e) => this.props.loanInformationOnChange("purpose", e)}>
                        <MenuItem value=" ">Choose one...</MenuItem>
                        <MenuItem value="auto_purchase">Auto Purchase</MenuItem>
                        <MenuItem value="auto_refiniance">Auto Refinance</MenuItem>
                        <MenuItem value="baby">Baby</MenuItem>
                        <MenuItem value="boat">Boat</MenuItem>
                        <MenuItem value="business">Business</MenuItem>
                        <MenuItem value="car_repair">Car Repair</MenuItem>
                        <MenuItem value="cosmetic">Cosmetic</MenuItem>
                        <MenuItem value="credit_card_refi">Credit Card Refinance</MenuItem>
                        <MenuItem value="debt_consolidation">Debt Consolidation</MenuItem>
                        <MenuItem value="emergency">Emergency</MenuItem>
                        <MenuItem value="engagement">Engagement</MenuItem>
                        <MenuItem value="green">Green</MenuItem>
                        <MenuItem value="home_improvement">Home Improvement</MenuItem>
                        <MenuItem value="home_purchase">Home Purchase</MenuItem>
                        <MenuItem value="home_refi">Home Refinance</MenuItem>
                        <MenuItem value="household_expenses">Household Expenses</MenuItem>
                        <MenuItem value="large_purchases">Large Purchases</MenuItem>
                        <MenuItem value="life_event">Life Event</MenuItem>
                        <MenuItem value="medical_dental">Medical Dental</MenuItem>
                        <MenuItem value="motorcycle">Motorcycle</MenuItem>
                        <MenuItem value="moving_relocation">Moving Relocation</MenuItem>
                        <MenuItem value="rv">RV</MenuItem>
                        <MenuItem value="special_occasion">Special Occasion</MenuItem>
                        <MenuItem value="student_loan">Student Loan</MenuItem>
                        <MenuItem value="student_loan_refi">Student Loan Refinance</MenuItem>
                        <MenuItem value="taxes">Taxes</MenuItem>
                        <MenuItem value="vacation">Vacation</MenuItem>
                        <MenuItem value="wedding">Wedding</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                        <MenuItem value="unknown">Unknown</MenuItem>
                    </Select>
                    <FormHelperText id="loanPurposeSelect">Select your loan purpose here</FormHelperText>    
                </FormControl>
                <FormControl className="formInputs">
                    <Input id="my-input" aria-describedby="my-helper-text" startAdornment={<InputAdornment position="start">$</InputAdornment>} value={this.props.requestJson.loanInformation.loanAmount}onChange={(e) => this.props.loanInformationOnChange("loanAmount", e)}/>
                    <FormHelperText id="my-helper-text">Enter your loan amount here</FormHelperText>
                </FormControl>
            </div>
            <h4 className="objectTitle">Mortgage Information</h4>
            <div className="mortgageInfo">
                <FormControl className="formInputs">
                    <Select id="propertyStatusSelect" aria-describedby="Please select your property status." value={this.props.requestJson.mortgageInformation.propertyStatus} onChange={(e) => this.props.mortgageInformationOnChange("propertyStatus", e)}>
                        <MenuItem value=" ">Choose one...</MenuItem>
                        <MenuItem value="own_outright">Own</MenuItem>
                        <MenuItem value="own_with_mortgage">Own With Mortgage</MenuItem>
                        <MenuItem value="rent">Rent</MenuItem>
                        <MenuItem value="unknown">Unknown</MenuItem>
                    </Select>
                    <FormHelperText id="propertyStatusSelect">Pick your property status here</FormHelperText> 
                </FormControl>
            </div>
            <h4 className="objectTitle">Credit Information</h4>
            <div className="creditInfo">
                <FormControl className="formInputs">
                    <Select id="creditRatingSelect" aria-describedby="Select your selt reported credit score here." value={this.props.requestJson.creditInformation.providedCreditRating} onChange={(e) => this.props.creditInformationOnChange("providedCreditRating", e)}>
                        <MenuItem value=" ">Choose one...</MenuItem>
                        <MenuItem value="excellent">Excellent</MenuItem>
                        <MenuItem value="good">Good</MenuItem>
                        <MenuItem value="fair">Fair</MenuItem>
                        <MenuItem value="poor">Poor</MenuItem>
                        <MenuItem value="limited">Limited</MenuItem>
                        <MenuItem value="unknown">Unknown</MenuItem>
                    </Select>
                    <FormHelperText id="creditRatingSelect">Select your self reported credit rating here</FormHelperText>
                </FormControl>
            </div>
            <h4 className="objectTitle">Financial Information</h4>
            <div className="finInfo">
                <FormControl className="formInputs">
                    <Select id="employmentStatusSelect" aria-describedby="Please select your employment status." value={this.props.requestJson.financialInformation.employmentStatus} onChange={(e) => this.props.financialInformationOnChange("employmentStatus", e)}>
                        <MenuItem value=" ">Choose one...</MenuItem>
                        <MenuItem value="employed">Employed</MenuItem>
                        <MenuItem value="employed_full_time">Full Time</MenuItem>
                        <MenuItem value="employed_part_time">Part Time</MenuItem>
                        <MenuItem value="military">Military</MenuItem>
                        <MenuItem value="not_employed">Not Employed</MenuItem>
                        <MenuItem value="self_employed">Self Employed</MenuItem>
                        <MenuItem value="retired">Retired</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                        <MenuItem value="unknown">Unknown</MenuItem>
                    </Select>
                    <FormHelperText id="employmentStatusSelect">Select your employment status here</FormHelperText>
                </FormControl>
                <FormControl className="formInputs">
                    <Select id="payFrequencySelect" aria-describedby="Please select your property status." value={this.props.requestJson.financialInformation.employmentPayFrequency} onChange={(e) => this.props.financialInformationOnChange("employmentPayFrequency", e)}>
                        <MenuItem value=" ">Choose one...</MenuItem>
                        <MenuItem value="weekly">Weekly</MenuItem>
                        <MenuItem value="biweekly">Biweekly</MenuItem>
                        <MenuItem value="twice_monthly">Twice Monthly</MenuItem>
                        <MenuItem value="monthly">Monthly</MenuItem>
                        <MenuItem value="unknown">Unknown</MenuItem>
                    </Select>
                    <FormHelperText id="payFrequencySelect">Select your pay frequency here</FormHelperText>
                </FormControl>
                <FormControl className="formInputs">
                    <Input id="incomeInout" aria-describedby="my-helper-text" startAdornment={<InputAdornment position="start">$</InputAdornment>} value={this.props.requestJson.financialInformation.annualIncome} onChange={(e) => this.props.financialInformationOnChange("annualIncome", e)}/>
                    <FormHelperText id="incomeInput">Enter your annual income here</FormHelperText>
                </FormControl>
            </div>
            <h4 className="objectTitle">Education Information</h4>
            <div className="eduInfo">
                <FormControl className="formInputs">
                    <Select id="educationStatusSelect" aria-describedby="Please select your education status." value={this.props.requestJson.educationInformation.educationLevel} onChange={(e) => this.props.educationInformationOnChange("educationLevel", e)}>
                        <MenuItem value=" ">Choose one...</MenuItem>
                        <MenuItem value="high_school">High School</MenuItem>
                        <MenuItem value="associate">Associate</MenuItem>
                        <MenuItem value="bachelors">Bachelors</MenuItem>
                        <MenuItem value="masters">Masters</MenuItem>
                        <MenuItem value="doctorate">Doctorate</MenuItem>
                        <MenuItem value="other_grad_degree">Other Graduate Degree</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                        <MenuItem value="unknown">Unknown</MenuItem>
                    </Select>
                    <FormHelperText id="educationStatusSelect">Pick your education status here.</FormHelperText> 
                </FormControl>
            </div>
            <h4 className="objectTitle">Legal Information</h4>
            <div className="legalInfo">
                <div className="checkBox">
                    <FormControl id="legalCheckbox" className="formInputs">
                        <Checkbox color="primary" onChange={(e) => this.props.legalInformationOnChange(e)}/>
                    </FormControl>
                </div>
                <p id="checkboxLanguage">{this.props.tcpaLanguage}</p>
            </div>
            <FormControl className="formSubmitButton">
                <div>
                    <Button id="submitButton" href="/pending" variant="contained" color="primary" onClick={(e) => this.props.submitButtonOnClick(e)}>Submit API Request</Button>    
                </div>
            </FormControl>
        </div>
        );
    }
}

export default Form;